import type { EducationMemberOption } from '@platform/billing';

/** 구성원이 이 회차에 이미 들어가 있는 상태. 없으면 null. */
export type MemberSessionState = 'registered' | 'pending';

/**
 * 구성원의 회차별 접수 상태 — 결제 완료면 'registered', 결제 대기면 'pending'.
 *
 * 둘 다 서버 중복 검사가 막는 범위라 화면은 둘 다 잠근다. 나누는 건 문구 때문이다 —
 * 결제창을 닫은 접수도 명부에 이미 올라가 있어, 합쳐 보이면 결제 안 한 사람이
 * "신청 완료" 로 보인다.
 */
export function memberSessionState(
  member: EducationMemberOption,
  sessionId: string,
): MemberSessionState | null {
  // `?? []` — 이 필드를 모르는 이전 서버 응답에서도 화면이 깨지지 않게 한다(배포 순서 어긋남 대비).
  if ((member.registeredSessionIds ?? []).includes(sessionId))
    return 'registered';
  if ((member.pendingSessionIds ?? []).includes(sessionId)) return 'pending';
  return null;
}
